// extracted by mini-css-extract-plugin
module.exports = {"container":"e_fA","msrp":"e_gA","save":"e_hA","discount":"e_iA","price":"e_jA"};